<template>
<div class="thal-page">
  <nav2 :title="title+$t('bet3D.t_1')"></nav2>
  <div class="bet3d-center">
    <div class="bet3d-time">{{$t('bet2D.t_2')}}{{ list_record.lottery_time }} </div>
    <div class="bet3d-item">
      <div class="bet3d-item-list">
        <div>{{$t('bet3D.t_2')}}</div>
        <div>{{$t('bet3D.t_3')}}</div>
        <div>{{$t('bet3D.t_4')}}</div>
        <div>{{$t('bet3D.t_5')}}</div>
      </div>
        <div class="bet3d-item-list" v-for="(item,index) in list" :key="index">
          <div>{{ item.code }}</div>
          <div>{{ item.odds }}</div>
          <div><span class="bet3d-del" @click.stop="_del_bet(item.playway_id)"><i class="el-icon-delete"></i></span></div>
          <div>
            <span class="bet3d-remove" @click.stop="_amount_add('3',index)"><i class="el-icon-remove-outline"></i></span>
            <input type="type" class="bet-input" v-model="item.amount" @input="_list_amount($event,index)"/>
            <span class="bet3d-remove" @click.stop="_amount_add('4',index)"><i class="el-icon-circle-plus-outline"></i></span>
          </div>
        </div>

    </div>
  </div>

  <div class="bet3d-submit">
    <div class="bet3d-num">
      <div>{{$t('bet3D.t_2')}}：<input type="type" v-model="code" placeholder="--" /></div>
      <div>
        <span class="bet3d-remove-num" @click.stop="_amount_add('1')"><i class="el-icon-remove"></i></span>
        <input type="type" v-model="amount" @input="_input_amount"/>
        <span class="bet3d-remove-num" @click.stop="_amount_add('2')"><i class="el-icon-circle-plus"></i></span>
      </div>
    </div>
    <div class="bet3d-confirm">
      <div class="bet3d-confirmColor" @click.stop="_code_confirm">{{$t('bet3D.t_6')}}</div>
    </div>
    <div class="bet-submit-note">
      <div class="bet-note-num"><span>{{$t('bet2D.t_5')}}</span><span>{{ noteNum }}</span></div>
      <div class="bet-note-amount"><span>{{$t('bet2D.t_6')}}</span><span>{{ totalAmount }}</span></div>
      <div class="submit-bet" @click.stop="_bet">{{$t('bet2D.t_7')}}</div>

    </div>
  </div>



  <!--  投注失败-->
  <div class="bet-cover" v-if="is_err">
    <div class="luck-num">
      <div class="bet-shortcut-title">{{$t('bet3D.t_13')}}<span @click.stop="_fast_click"><i class="el-icon-circle-close"></i></span></div>
      <div class="err-list">
        <div>{{ $t('recordsBet.t_8') }}</div><div>{{$t('recordsBet.t_9')}}</div><div>{{ $t('bet3D.t_14') }}</div>
      </div>
      <div v-for="(item,index) in err_list" class="err-list">
        <div>{{item.number}}</div><div>{{item.bet}}</div><div style="color: #ff0000">{{item.error}}</div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
  import nav2 from '../THAL/navs'
    export default {
    components:{nav2},
        name: "bet3D",
      data(){
      return{
        value:0,
        lottery_id:'',
        title:'',
        lottery_abbr:'',
        record_id:'',
        code:'',
        is_err:false,
        err_list:[],
        list_record:'',
        list:[],
        amount:0,
        is_confirm:false,
        totalAmount:0,
        noteNum:0,
        is_bet:false,
      }
      },
      created() {
        let that=this;
        let lottery_id=that.$route.query.lottery_id;

        if(lottery_id!='' && lottery_id!=undefined){
          that.lottery_id=lottery_id;
          that.title=that.$route.query.lottery_name;
          that.lottery_abbr=that.$route.query.lottery_abbr;
          if(that.$route.query.record_id!='' && that.$route.query.record_id!=undefined){
            that.record_id=that.$route.query.record_id;
            that._record();
          }else{

          }
          /*that._lottery();*/
        }

      },
      methods:{
        _fast_click:function () {
          let that=this;
          that.is_err=false;
        },
        _del_bet:function (playway_id){
          let _self=this;
          for(var i=0;i<_self.list.length;i++){
            if(playway_id==_self.list[i].playway_id){
              _self.list.splice(i,1);
              _self._total_amount();
            }
          }

        },
        _list_amount:function (e,index){
          let _self=this;
          if(e.target.value>0){
            _self.list[index].amount=e.target.value;
            _self._total_amount();
          }


        },
        _amount_add:function (m,index){
          let _self=this;
          if(m==1){
            if(parseFloat(_self.amount)>0){
              _self.amount=parseFloat(_self.amount)-1;
            }
          }else if(m==2){
            _self.amount=parseFloat(_self.amount)+1;
          }else if(m==3){
            if(parseFloat(_self.list[index].amount)>0){
              _self.list[index].amount=parseFloat(_self.list[index].amount)-1;
            }
          }else if(m==4){
            _self.list[index].amount=parseFloat(_self.list[index].amount)+1;
          }
          _self.$forceUpdate();
          _self._total_amount();

        },
        _total_amount:function (){
          let _self=this;
          _self.noteNum=_self.list.length;
          var sum=0;
          for(var i=0;i<_self.list.length;i++){
            sum+=_self._accMul(1,_self.list[i].amount);

          }
          _self.totalAmount=sum;
        },
        _input_amount:function (e){
          let _self=this;
          if(parseFloat(e.target.value)>0){
            _self.amount=e.target.value;
          }
          _self._total_amount();
        },
        _accMul:function (arg1,arg2){
          var m=0,s1=arg1.toString(),s2=arg2.toString();
          try
          {
            m+=s1.split(".")[1].length

          }
          catch(e)
          {}
          try
          {
            m+=s2.split(".")[1].length
          }
          catch(e)
          {}
          return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
        },
        _record:function (){
          let _self=this;
          this._PublicFun.getData('2', 'get', 'lottery/section/'+_self.lottery_id, {}, function (result) {
            if(result.data['status_code']==200){
              let list=result.data['data'];
              if(list.length>0){
                if(_self.record_id!=''){
                  for(var i=0;i<list.length;i++){
                    let stop_buy_time=list[i].stop_buy_time;
                    let timearr=stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":");
                    list[i].lottery_time=timearr[1]+':'+timearr[2];
                    if(list[i].record_id==_self.record_id){
                      _self.list_record=list[i];
                    }
                  }
                }else{
                  /*_self.list_record=list[0];*/
                  _self.$router.back();

                }
              }else{
                _self.$router.back();
              }


            }else{
              Toast(result.data['message']);
              _self.$router.back();
            }

          })
        },
        _bet:function (){
          let _self=this;
          let msg=1;
          let bets=[];
          for(var i=0;i<_self.list.length;i++){
            if(parseFloat(_self.list[i].amount)>0){
              let list={'playway_id':_self.list[i].playway_id,'bet':_self.list[i].amount};
              bets.push(list)
            }else{
              msg=0;
            }
          }
          if(msg==0){
            Toast(_self.$t('bet3D.t_11'))
          }else{
            if(bets.length>0){
              bets=JSON.stringify(bets);
              if(_self.is_bet)
                return false;
              _self.is_bet=true;
              this._PublicFun.getData('2', 'post', 'lottery/bet', {'lottery_id':_self.lottery_id,'record_id':_self.record_id,'bets':bets}, function (result) {
                if(result.data['status_code']==200){
                  _self.is_bet=false;
                  _self.noteNum=0;
                  _self.totalAmount=0;
                  _self.list=[];
                  if(result.data['data'].length==0){
                    Toast(_self.$t('bet3D.t_8'));
                  }else{
                    _self.err_list=result.data['data'];
                    _self.is_err=true;
                  }
                }else{
                  Toast(result.data['message']);
                  _self.is_bet=false;
                }

              })
            }else{
              Toast(_self.$t('bet3D.t_15'))
            }
          }
        },
        _code_confirm:function (){
          let _self=this;
          if(_self.code.length==3){
            if(_self.is_confirm)
              return false;
            _self.is_confirm=true;
            this._PublicFun.getData('2', 'get', 'lottery/playway/'+_self.lottery_id+'/'+_self.record_id+'/'+_self.code, {}, function (result) {
              if(result.data['status_code']==200){
                result.data['data'].amount=_self.amount;
                if(parseFloat(result.data['data'].expect_bet_tally)<parseFloat(result.data['data'].expect_bet_limit)){
                  _self.list.push(result.data['data']);
                  _self._total_amount();
                }else{
                  Toast(_self.$t('bet3D.t_10'));
                }
                _self.is_confirm=false;
              }else{
                _self.is_confirm=false;
                Toast(result.data['message']);
              }

            })

          }else{
            Toast(_self.$t('bet3D.t_9'))
          }
        }
      }
    }
</script>

<style scoped>
  .bet3d-center{
    display: block;
    width: 100%;
    margin: 55px auto 110px;
    padding: 0;
    max-width: 750px;

  }
  .bet3d-time{
    display: block;
    width: 94%;
    margin: 0 auto;
    padding: 0;
    position: relative;
    min-height: 20px;
    text-align: right;
    color: #ff0000;
    font-size: 12px;

  }
  .bet3d-time:after{
    position: absolute;
    content: '';
    right: 130px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-bottom: 1px solid #dddddd;
  }
  .bet3d-item{
    display: block;
    width: 94%;
    margin: 0 auto;
    padding: 0;
  }
  .bet3d-item-list{
    display: flex;
    width: 100%;
    margin: 0 auto;
    padding: 5px 0;
    color: #F4D788;
    border-bottom: 1px solid #F4D788;
    align-items: center;
    justify-content: center;
  }
  .bet3d-item-list:first-child{
    color: #dddddd;
    font-size: 12px;
    border-bottom: 1px solid #dddddd;
  }
  .bet3d-item-list div{
    text-align: center;
  }
  .bet3d-item-list div:first-child,.bet3d-item-list div:nth-child(2),.bet3d-item-list div:nth-child(3){
    width: 20%;
  }
  .bet3d-item-list div:last-child{
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bet3d-del{
    color: #F4D788;
    font-size: 20px;
    cursor: pointer;
  }
  .bet3d-remove{
    font-size:18px;
    color: #F4D788;
    cursor: pointer;

  }
  .bet-input{
    display: block;
    width: 80px;
    border: 1px solid #F4D788;
    border-radius: 3px;
    outline: none;
    padding: 0;
    height: 20px;
    line-height: 20px;
    margin: 0 5px;
    color: #F4D788;
    background-color: transparent;
    text-align: center;
  }
  .bet3d-submit{
    position: fixed;
    z-index: 9;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    bottom: 0;
    background-color: #E8BD70;
    height: 110px;
    max-width: 750px;
  }
  .bet3d-num{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 96%;
    margin: 5px auto;
    padding: 0;

  }
  .bet3d-num div{
    display: flex;
    width: 50%;
    margin: 0;
    padding: 0;
    align-items: center;
    font-size: 13px;
  }
  .bet3d-num div input{
    display: block;
    width: 68%;
    margin: 0;
    height:25px;
    text-align: center;
    border: 1px solid #333333;
    line-height: 25px;
    border-radius: 8px;
    outline: none;
    background-color: #EDD185;
  }
  .bet3d-remove-num{
    font-size: 20px;
    cursor: pointer;
  }
  .bet3d-confirm{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 94%;
    margin: 8px auto;
    text-align: center;
  }
  .bet3d-confirmColor{
    display: block;
    text-align: center;
    margin: 0;
    background-color: #2D2D2D;
    line-height: 25px;
    padding: 0 10px;
    border-radius: 5px;
    font-size: 12px;
    color: #E8BD70;
    cursor: pointer;
  }
  .bet-submit-note{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 96%;
    margin:5px auto;
    padding: 0;
    font-size: 12px;
  }
  .bet-note-num,.bet-note-amount{
    display: flex;
    align-items: center;
  }
  .bet-note-amount{
    width: 55%;
    justify-content: center;
  }
  .bet-note-num span:last-child{
    border: 1px solid #2D2D2D;
    width: 35px;
    height: 25px;
    color: #2D2D2D;
    line-height: 25px;
    border-radius: 5px;
    text-align: center;
  }
  .bet-note-amount span:last-child{
    display: block;
    width: 65%;
    height:25px;
    padding: 0 3px;
    line-height: 25px;
    text-align: right;
    border: 1px solid #2D2D2D;
    border-radius: 5px;
  }
  .submit-bet{
    display: block;
    width: 60px;
    height: 25px;
    border-radius: 5px;
    background-color: #2D2D2D;
    text-align: center;
    color: #E8BD70;
    line-height: 25px;
  }
  .bet-cover{
    position: fixed;
    z-index: 99;
    left: 0;
    width: 100%;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
  }
  .luck-num{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 80%;
    background-color: #FFFFFF;

  }
  .luck-num .bet-shortcut-title{
    color: #000000;
  }
  .luck-num .bet-shortcut-title span{
    color: #000000;
  }
  .bet-shortcut-title{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    text-align: center;
    position: relative;
    color: #dddddd;
  }
  .bet-shortcut-title span{
    position: absolute;
    top: 50%;
    right: 10px;
    color: #E9CD83;
    font-size:28px;
    transform: translateY(-50%);
  }
  .err-list{
    display: flex;
    width: 96%;
    margin: 0 auto;
    padding: 5px 0;
    border-top: 1px solid #DCDCDC;
    font-size: 12px;
    color: #303133;

  }
  .err-list div{
    display: block;
    width: 50%;
    margin: 0 ;
    padding: 0;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/THAL/bet3D.vue